/*
# -----------------------------------------------------------------------------
# Component: marineDataMixin.js
# Author: ssy@pst.sg
# Created Date: 20/Feb/2020
# Comments: Responsible for shared components - Policy Type Parameters
# -----------------------------------------------------------------------------
*/

import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export const benefitDataMixin = {
  data() {
    return {
      sideFunction: [
        {
          text: 'Vessel Class',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'vslCls' }
        },
        {
          text: 'Vessel Construction',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'vslConstn' }
        }
      ]
    }
  },
  methods: {
    doInit(pKey) {
      const apiURI = this.menu.benefitParamList
      if (apiURI) {
        const params = {
          paramKey: pKey,
          paramString: ''
        }
        this.loading = true
        this.$http.get(expandURI(apiURI, params)).then(result => {
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(result => {
              const convertList = {
                paramName: result.paramName,
                paramType: result.paramType,
                paramDesc: result.paramDesc,
                paramLongDesc: result.paramLongDesc
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    }
  },
  components: {
    SideFunctionMenu
  },
  computed: {
    menu() {
      return this.$store.state.benefitParam.menu
    }
  },
  mixins: [
    MessageMixin
  ]
}
